import { render, staticRenderFns } from "./QuizBankEdit.vue?vue&type=template&id=60da0739&scoped=true"
import script from "./QuizBankEdit.vue?vue&type=script&lang=js"
export * from "./QuizBankEdit.vue?vue&type=script&lang=js"
import style0 from "./QuizBankEdit.vue?vue&type=style&index=0&id=60da0739&prod&lang=scss&scoped=true"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da0739",
  null
  
)

export default component.exports